


































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

import ProductCategoriesModal from '../modals/ProductCategoriesModal.vue';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'product-categories',
    components: {
        ProductCategoriesModal,
        Spinner,
    },
    computed: {
        ...mapState('productCategories', ['allProductCategories', 'nestedProductCategories', 'allProductCategoriesLoading']),
    },
})
export default class ProductCategories extends Vue {
    public allProductCategories!: any;
    public nestedProductCategories!: any;
    public allProductCategoriesLoading!: any;
    public category_search: any = '';
    public categoriesPerPage: number = 10;

    private view = 'tree';
    private categoriesCurrentPage = 1;

    get allProductCategoriesCollection() {
        return this.allProductCategories.filter((cat) => {
            return (
                cat.name.includes(this.category_search) ||
                cat.name.toLowerCase().includes(this.category_search) ||
                cat.name.toUpperCase().includes(this.category_search)
            );
        });
    }

    allProductCategoriesHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'name', label: 'Nombre' },
        { thClass: 'th', key: 'edit', label: '' },
        { thClass: 'th', key: 'delete', label: '' },
    ];

    onOpenProductCategoryModal(id: string | null = null) {
        this.$store.dispatch('productCategories/getOne', id);
        setTimeout(() => {
            this.$bvModal.show('product-categories-modal');
        }, 400);
    }

    onDel(node) {
        // console.log(node.id);
        this.onOpenProductCategoryModal(node.id);
        // node.remove();
    }

    onDeleteProductCategoryModal(id: string) {
        this.$store.dispatch('productCategories/deleteOne', { id, vm: this });
    }

    mounted() {
        this.$store.dispatch('productCategories/getAll');
    }
}
